// extracted by mini-css-extract-plugin
export default {"hr":"Hr_hr__6zFzM"};